<template>
	<div class="flex flex-col items-center">
		<span class="uppercase font-medium">{{ $t("contacts.officeRo") }}</span>
		<a :href="$t('contacts.officeLocationRoOnMap')" target="_blank" class="mb-4 text-dj-red hover:underline">
			{{ $t("contacts.officeLocationRo") }}
		</a>
		<ContactUsGroup v-for="(group, index) in contacts" :key="index" :name="group.groupName">
			<ContactUsCard
				v-for="(member, index) in group.members"
				:key="index"
				:name="member.name"
				:role="member.role"
				:email="member.email"
				:phone="member.phone"
			/>
		</ContactUsGroup>
		<div class="flex flex-col items-center py-4">
			<span class="uppercase font-medium mb-2">{{ $t("contacts.companyDataRo.title") }}</span>
			<div class="text-center" v-html="$t('contacts.companyDataRo.data')"></div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
	name: "ContactUsRo",
	setup() {
		const { getEmail } = usePublicConfig();
		const contacts = computed(() => [
			{
				groupName: "customerServiceB2B",
				members: [
					{
						name: "",
						role: "",
						email: getEmail("business", "RO"),
						phone: "",
					},
				],
			},
		]);

		return {
			contacts,
		};
	},
});
</script>
